<app-callcard-media-buttons *ngIf="myCard" [callcard]="myCard"></app-callcard-media-buttons>
<app-media-messages-new></app-media-messages-new>
<ul>
  <li *ngFor="let mediaMessage of mediaMessages">
    <app-media-message-item [mediaMessage]="mediaMessage"></app-media-message-item>
  </li>
</ul>
